<agpr-take-over-panel
    #takeOverPanel
    id="agentUsageDialog"
    class="agpr-agentUsageDialog"
    header="AutomationAgents.usage.heading"
    [overlayContainer]="overlayContainer"
    [animationTrigger]="animationTrigger"
    [hideSlideOverlay]="hideSlideOverlay"
    [responsiveWidth]="true"
    [minPanelWidth]="960"
    [maxPanelWidth]="1400"
    [fullHeight]="true"
    [showFooter]="false"
    (visibleChange)="onVisibleChange($event)"
    [subHeader]="'AutomationAgents.usage.needMore'"
>
    <!-- Sits on the title's own line rather than in a bar of its own -->
    <ng-template #takeOverHeaderStart>
        <agpr-button
            id="agentUsageDialog.collapse"
            class="agpr-agentUsageDialog-collapse"
            [style]="buttonTypes.icon"
            icon="fa-solid fa-angle-right"
            tooltip="AutomationAgents.usage.collapse"
            tooltipPosition="right"
            [ariaLabel]="'AutomationAgents.usage.collapse' | localize"
            [initiallyFocusable]="false"
            (click)="collapse()"
        ></agpr-button>

    </ng-template>
    <div class="agpr-agentUsageDialog-body">
        <!-- The panel exactly as it renders inline, minus its own header -->
        <agpr-agent-usage-dashboard
            class="agpr-agentUsageDialog-panel"
            [showHeader]="false"
            [selectedPeriod]="selectedPeriod"
            (periodSelected)="periodChanged($event)"
        ></agpr-agent-usage-dashboard>

        <section class="agpr-agentUsageDialog-consumers" [agprLoading]="loading">
            <h3 class="u-srOnly">{{ 'AutomationAgents.usage.consumers' | localize }}</h3>
            @let consumers = consumers$ | async;

            <div class="agpr-agentUsageDialog-consumersHeader">
                <span>{{ 'AutomationAgents.usage.consumer' | localize }}</span>
                <span>{{ 'AutomationAgents.usage.consumerUsage' | localize }}</span>
                <span>{{ 'AutomationAgents.usage.consumerType' | localize }}</span>
            </div>

            <agpr-scroll-panel id="agentUsageDialog.consumersScroll" class="agpr-agentUsageDialog-consumersScroll">
                <ul class="agpr-agentUsageDialog-consumerList">
                    @for (consumer of consumers; track $index) {
                        <li class="agpr-agentUsageDialog-consumerRow">
                            <span class="agpr-agentUsageDialog-consumerName">{{ consumer.name }}</span>
                            <span>{{ consumer.usage }}</span>
                            <span>{{ consumer.type | localize }}</span>
                        </li>
                    } @empty {
                        <li class="agpr-agentUsageDialog-consumerEmpty">
                            <agpr-message
                                id="agentUsageDialog.consumersEmpty"
                                [severity]="messageSeverity.noContent"
                                [bottomMargin]="false"
                            >
                                {{ 'AutomationAgents.usage.consumers.empty' | localize }}
                            </agpr-message>
                        </li>
                    }
                </ul>
            </agpr-scroll-panel>
        </section>
    </div>
</agpr-take-over-panel>
